import { Button, styled } from "@mui/material";
import { useState } from "react";

const SecondaryButton = ({ img, hoverImg, imgWidth = 18, title, ...props }) => {
  const [isHover, setIsHover] = useState(false);
  return (
    <CustomButton
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      {...props}
    >
      <span>
        {img && (
          <img src={isHover ? hoverImg : img} alt={title} width={imgWidth} />
        )}
        {title}
      </span>
    </CustomButton>
  );
};

const CustomButton = styled(Button)(
  ({ theme, variant, fontWeight, padding, fontSize }) => ({
    mt: 2,
    background: theme.palette.background.default,
    textTransform: "capitalize",
    transition: "all 0.35s ease-in-out",
    position: "relative",
    overflow: "hidden",
    boxShadow: "1px 3px 12px black",
    padding: padding,
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: 0,
      height: "100%",
      backgroundColor: theme.palette.primary.hover,
      transition: "all 0.35s ease-in-out",
    },
    "&:hover:before": {
      width: "100%",
    },
    span: {
      display: "flex",
      gap: "13px",
      zIndex: 1,
      fontWeight: fontWeight ? fontWeight : "bold",
      fontSize: fontSize || "1.6vh",
      color:
        variant === "outlined"
          ? theme.palette.primary.main
          : theme.palette.text.dark,
    },
    "&:hover": {
      span: {
        color: theme.palette.text.dark,
        transition: "all 0.35s ease-in-out",
      },
    },
  })
);

export default SecondaryButton;
